/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EventUuidListDto } from '../../models/event-uuid-list-dto';
import { PlayByPlayModelGameDto } from '../../models/play-by-play-model-game-dto';

export interface ScoutingControllerExternalEventsBulkPresignedUrls$Params {
      body: EventUuidListDto
}

export function scoutingControllerExternalEventsBulkPresignedUrls(http: HttpClient, rootUrl: string, params: ScoutingControllerExternalEventsBulkPresignedUrls$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PlayByPlayModelGameDto>>> {
  const rb = new RequestBuilder(rootUrl, scoutingControllerExternalEventsBulkPresignedUrls.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PlayByPlayModelGameDto>>;
    })
  );
}

scoutingControllerExternalEventsBulkPresignedUrls.PATH = '/scouting/external/events/bulk/presigned-urls';
